export const isSvg = file => {
  if (!file) return false;

  if (file.type && file.type.toLowerCase().includes("svg")) {
    return true;
  }

  if (file.name) {
    const ext = file.name.split(".").pop();
    if (ext && ext.toLowerCase() === "svg") {
      return true;
    }
  }

  return false;
};

export const isVector = url => {
  if (!url) return false;
  const urlWithoutQuery = url.split("?")[0];
  const fileExtension = urlWithoutQuery.split(".").pop();
  if (fileExtension && fileExtension.toLowerCase() === "svg") {
    return true;
  }
  return false;
};
